import { render, staticRenderFns } from "./RecipientCivil.vue?vue&type=template&id=398b3716&"
import script from "./RecipientCivil.vue?vue&type=script&lang=js&"
export * from "./RecipientCivil.vue?vue&type=script&lang=js&"
import style0 from "./RecipientCivil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports